<template>
  <div>
    <div class="bg-body"/>
    <div>
      <div class="file-head-bg"/>
      <div class="col-md-12 file-head-content">
        <div class="file-header">
          <div class="col-10">
            <div class="file-header-title">Dossier de candidature</div>
          </div>
          <div class="col-2 file-header-logo"><img src="@/assets/img/logo.png"></div>
        </div>
      </div>
    </div>

    <FileForm
        :ifCandidature=ifCandidature
        :ifContratR2=ifContratR2
        :statut=statut
    />
    <FileEligible
        :comments=comments
        :ifEligible=ifEligible
        :ifTestFinished=ifTestFinished
        :statut=statut
    />
    <FileTest
        :dayRemaining=dayRemaining
        :ifTestEnCours=ifTestEnCours
        :ifTestFinished=ifTestFinished
        :ifTestOpened=ifTestOpened
        :ifTestSend=ifTestSend
        :NB_H_RAN_MA_OF=NB_H_RAN_MA_OF
        :NB_H_RAN_FR_OF=NB_H_RAN_FR_OF
        :NB_H_RAN_AR_OF=NB_H_RAN_AR_OF
    />
    <FileInterview
        :campusEntretien=campusEntretien
        :comments=comments
        :dateEntretien=dateEntretien
        :statutEntretien=statutEntretien
    />
    <FileSignature
        :ifContratR2=ifContratR2
        :statut=statut
    />
  </div>
</template>

<script>

import FileForm from '@/components/File/Form.vue'
import FileEligible from '@/components/File/Eligible.vue'
import FileTest from '@/components/File/Test.vue'
import FileInterview from '@/components/File/Interview.vue'
import FileSignature from '@/components/File/Signature.vue'

import UserService from "@/services/user.service";

export default {
  name: "File",
  components: {
    FileForm,
    FileEligible,
    FileTest,
    FileInterview,
    FileSignature
  },
  data() {
    return {
      ifCandidature: null,
      ifEligible: null,
      statut: '',
      ifTestOpened: false,
      ifTestFinished: false,
      ifTestEnCours: false,
      ifContratR2: false,
      ifTestSend: false,
      dayRemaining: 0,
      statutEntretien: '',
      dateEntretien: '',
      campusEntretien: '',
      comments: '',
      NB_H_RAN_MA_OF: null,
      NB_H_RAN_FR_OF: null,
      NB_H_RAN_AR_OF: null
    }
  },
  mounted() {
    UserService.getDashboardContent("File").then(
        (response) => {
          this.ifCandidature = response.data.ifCandidature
          this.ifEligible = response.data.ifEligible
          this.statut = response.data.statut
          this.ifTestOpened = response.data.ifTestOpened
          this.ifTestFinished = response.data.ifTestFinished
          this.ifTestEnCours = response.data.ifTestEnCours
          this.ifTestSend = response.data.ifTestSend

          localStorage.setItem('limitTest', response.data.timestampDateLimitTest)
          localStorage.setItem('rappelLimitTest', 0)

          this.dayRemaining = response.data.dayRemaining
          this.statutEntretien = response.data.statutEntretien
          this.dateEntretien = response.data.dateEntretien
          this.campusEntretien = response.data.campusEntretien
          this.ifContratR2 = response.data.ifContratR2
          this.comments = response.data.comments
          this.NB_H_RAN_MA_OF = response.data.NB_H_RAN_MA_OF
          this.NB_H_RAN_FR_OF = response.data.NB_H_RAN_FR_OF
          this.NB_H_RAN_AR_OF = response.data.NB_H_RAN_AR_OF
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );
  },
};
</script>
